import React, { FC, useRef, useState } from 'react';
import moment from 'moment';

import { fc } from 'i18n';
import { ReactPortal } from 'components/molecules/react-portal';

import styles from './styles.module.css';

interface IRunwayStatusTileProps {
  label: string;
  value: (string | number)[];
  statusAt?: string;
}

export const RunwayStatusColumn: FC<IRunwayStatusTileProps> = ({ label, value, statusAt }) => {
  const wrapperRef = useRef<HTMLDivElement | null>(null);

  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState<Record<string, number>>({ top: 0, left: 0 });

  const onMouseOver = () => {
    if (wrapperRef.current) {
      const { top, left } = wrapperRef.current.getBoundingClientRect();

      setPosition({ top: top, left: left + 30 });
      setIsVisible(true);
    }
  };

  const onMouseOut = () => setIsVisible(false);

  return (
    <div ref={wrapperRef} onMouseOut={onMouseOut} onMouseOver={onMouseOver}>
      <div className={`${styles.column} ${label === 'CAT' && !!statusAt ? styles.cat : ''}`}>
        <div className={styles.columnTitle}>{label}</div>
        <div className={styles.statusWrapper}>
          {value.map((value, index) => (
            <div key={index} className={styles.columnText}>
              {value}
            </div>
          ))}
        </div>
      </div>
      {label === 'CAT' && !!statusAt && (
        <ReactPortal>
          {isVisible ? (
            <div className={styles.tooltip} style={{ ...position }}>
              <span> {`${fc('updated at')}:`}</span>&nbsp;
              <span className={styles.tooltipText}>{statusAt}</span>
            </div>
          ) : (
            <div />
          )}
        </ReactPortal>
      )}
    </div>
  );
};
